import { PaymentForm } from "tm-shared/types";

export const getPaymentFormText = (form: string) =>
    form === PaymentForm.Cash2 ? "Готівка" : "Безготівка";
